var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sc-card',[_c('div',{class:[("sc-title-bar " + _vm.$mq)]},[_c('city-title',{attrs:{"city":_vm.city}}),_c('date-time',{attrs:{"timeZone":_vm.timeZone}}),_c('weather')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }